import classnames from "classnames"
import { TimelineEventProps } from "./types"

/**
 * Represents a single event in the timeline. It encapsulates the marker, header and body
 *
 * @component
 * @example
 * <Timeline.Event>
 *   <Timeline.Marker>
 *   <Timeline.Header title="Event" />
 * </Timeline.Event>
 */
export const TimelineEvent = ({ className, children, ...rest }: TimelineEventProps) => {
  return (
    <li {...rest} className={classnames("ms-6 space-y-2 pb-3", className)} role="article">
      {children}
    </li>
  )
}

TimelineEvent.displayName = "TimelineEvent"
